import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Message from "../components/Message";
import Loading from "../components/Loading";
import FormContainer from "../components/FormContainer";
import { listProductDetails, updateProduct } from "../redux/actions/productActions";
import axios from "axios";

const EditProductScreen = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  let params = useParams();
  const productID = params.id;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState(0);
  const [image, setImage] = useState("");
  const [uploading, setUploading] = useState(false);
  const [sizes, setSizes] = useState([{ size: "", quantity: 0 }]);
  const [carouselImages, setCarouselImages] = useState([]);
  const [uploadingCarousel, setUploadingCarousel] = useState(false);


  const { product, loading, error } = useSelector(state => state.productDetails);
  const { loading: loadingUpdate, success: successUpdate, error: errorUpdate } = useSelector(state => state.productUpdate);

  useEffect(() => {
    if (successUpdate) {
      navigate("/admin/products");
    } else {
      if (!product || product._id !== productID) {
        dispatch(listProductDetails(productID));
      } else {
        setName(product.name || "");
        setDescription(product.description || "");
        setCategory(product.category || "");
        setPrice(product.price || 0);
        setImage(product.image || "");
        setSizes(product.sizes && product.sizes.length > 0 ? product.sizes : [{ size: "", quantity: 0 }]);
        setCarouselImages(product.carouselImages || []);  // <-- Add this line

      }
    }
  }, [dispatch, product, productID, successUpdate]);

  const handleSizeChange = (index, field, value) => {
    const updatedSizes = [...sizes];
    updatedSizes[index][field] = field === "quantity" ? Number(value) : value;
    setSizes(updatedSizes);
  };

  const addSizeRow = () => setSizes([...sizes, { size: "", quantity: 0 }]);
  const removeSizeRow = (index) => setSizes(sizes.filter((_, i) => i !== index));

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      updateProduct({
        _id: productID,
        name,
        description,
        category,
        price,
        image,
        sizes,
        carouselImages,  // Added here
        numReviews: 0,
      })
    );
  };

  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);

    setUploading(true);

    try {
      const config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

const { data } = await axios.post(
  `${process.env.REACT_APP_BACKEND_URL}/api/upload`,
  formData,
  config
);

      setImage(data.imageUrl);
      setUploading(false);
    } catch (error) {
      console.error(error.message);
      setUploading(false);
    }
  };


  const uploadMultipleFilesHandler = async (e) => {
  const files = Array.from(e.target.files);
  setUploadingCarousel(true);

  try {
    const uploadedUrls = [];

    for (const file of files) {
      const formData = new FormData();
      formData.append("image", file);

      const config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/upload`,
        formData,
        config
      );

      uploadedUrls.push(data.imageUrl);
    }

    setCarouselImages([...carouselImages, ...uploadedUrls]);
    setUploadingCarousel(false);
  } catch (error) {
    console.error(error.message);
    setUploadingCarousel(false);
  }
};



  return (
    <FormContainer>
      <h2>Edit Product</h2>
      {errorUpdate && <Message variant="danger">{errorUpdate}</Message>}
      {loading ? (
        <Loading />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="name" className="mt-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Name"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="description" className="mt-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Description"
              value={description}
              onChange={e => setDescription(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="category" className="mt-3">
            <Form.Label>Category</Form.Label>
            <Form.Control
              type="text"
              placeholder="Category"
              value={category}
              onChange={e => setCategory(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="price" className="mt-3">
            <Form.Label>Price</Form.Label>
            <Form.Control
              type="number"
              placeholder="Price"
              value={price}
              onChange={e => setPrice(e.target.value)}
              required
            />
          </Form.Group>

              <Form.Group controlId="image" className="mt-3">
                <Form.Label>Image</Form.Label>
                <Form.Control
                  type="file"
                  onChange={uploadFileHandler}
                />
                {uploading && <Loading />}
                {image && (
                  <div className="mt-2">
                    <img
                      src={image}
                      alt="Product Preview"
                      style={{ width: "150px", borderRadius: "8px" }}
                    />
                  </div>
                )}
              </Form.Group>


                <Form.Group controlId="carouselImages" className="mt-3">
  <Form.Label>Carousel Images (upload multiple)</Form.Label>
  <Form.Control
    type="file"
    multiple
    onChange={uploadMultipleFilesHandler}
  />
  {uploadingCarousel && <Loading />}
  <div className="mt-2 d-flex flex-wrap">
    {carouselImages.map((img, index) => (
      <div key={index} style={{ position: 'relative', marginRight: '10px', marginBottom: '10px' }}>
        <img
          src={img}
          alt={`carousel-${index}`}
          style={{ width: '100px', height: 'auto', borderRadius: '8px' }}
        />
        <Button
          variant="danger"
          size="sm"
          onClick={() => {
            setCarouselImages(carouselImages.filter((_, i) => i !== index));
          }}
          style={{ position: 'absolute', top: 0, right: 0, padding: "0 5px" }}
        >
          &times;
        </Button>
      </div>
    ))}
  </div>
</Form.Group>




          <Form.Group className="mt-3">
            <Form.Label>Sizes & Quantities</Form.Label>
            {sizes.map((item, index) => (
              <div key={index} className="d-flex align-items-center mb-2">
                <Form.Control
                  type="text"
                  placeholder="Size (e.g. S, M, L)"
                  value={item.size}
                  onChange={e => handleSizeChange(index, "size", e.target.value)}
                  style={{ width: "100px", marginRight: "10px" }}
                  required
                />
                <Form.Control
                  type="number"
                  placeholder="Quantity"
                  value={item.quantity}
                  onChange={e => handleSizeChange(index, "quantity", e.target.value)}
                  style={{ width: "100px", marginRight: "10px" }}
                  min="0"
                  required
                />
                <Button variant="danger" onClick={() => removeSizeRow(index)}>X</Button>
              </div>
            ))}
            <Button variant="primary" onClick={addSizeRow}>Add Size</Button>
          </Form.Group>

          <Button className="mt-3" type="submit" variant="primary">
            {loadingUpdate ? <Loading /> : "Save"}
          </Button>
        </Form>
      )}
    </FormContainer>
  );
};

export default EditProductScreen;
